import { SignInPage } from '@backstage/core-components';
import {
  configApiRef,
  createFrontendModule,
  githubAuthApiRef,
  googleAuthApiRef,
  useApi,
} from '@backstage/frontend-plugin-api';
import {
  SignInPageBlueprint,
  SignInPageProps,
} from '@backstage/plugin-app-react';

const githubProvider = {
  id: 'github-auth-provider',
  title: 'GitHub',
  message: 'Sign in with your GitHub account in the Playpilot org',
  apiRef: githubAuthApiRef,
};

const googleProvider = {
  id: 'google-auth-provider',
  title: 'Google',
  message: 'Sign in with your playpilot.com Google account',
  apiRef: googleAuthApiRef,
};

// The backend only registers the guest provider in development, so offering it
// anywhere else would be a button that always fails.
const PlaypilotSignInPage = (props: SignInPageProps) => {
  const isDevelopment =
    useApi(configApiRef).getOptionalString('auth.environment') ===
    'development';
  return (
    <SignInPage
      {...props}
      providers={
        isDevelopment
          ? ['guest', githubProvider, googleProvider]
          : [githubProvider, googleProvider]
      }
    />
  );
};

export const signInModule = createFrontendModule({
  pluginId: 'app',
  extensions: [
    SignInPageBlueprint.make({
      params: { loader: async () => PlaypilotSignInPage },
    }),
  ],
});
